import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './styles.css'

class Container extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    size: PropTypes.oneOf(['small', 'medium', 'large', 'full']),
  }

  static defaultProps = {
    className: '',
    size: 'medium',
  }

  getClassName() {
    return classnames(
      styles.root,
      styles[this.props.size],
      this.props.className,
    )
  }

  render() {
    const { children, ...restProps } = this.props

    return (
      <div {...restProps} className={this.getClassName()}>
        {children}
      </div>
    )
  }
}

export default Container



// WEBPACK FOOTER //
// ../source/layouts/Container/index.js